import React, { useCallback } from 'react';
import { Pack, RePack } from 'types';
import { InteractionSource } from 'utils/analytics/AnalyticsV2Service.generated';
import PlayerButton from 'components/CommonUi/PlayerButton/PlayerButton';
import { useTrackingContext } from 'contexts/TrackingContext/TrackingContext';
import {
    PackCardPlayButtonClickTrackerType,
    PackPlayButtonClickTrackerV2Type,
} from 'contexts/TrackingContext/TrackingContext.types';
import { useCarouselContext } from '../contexts/CarouselContext';

export const useCardPlayer = ({
    item,
    getPackCardPlayButtonClickTracker,
    getPackPlayButtonClickTrackerV2,
    carouselName,
    carouselGuid,
}: {
    item: Pack | RePack;
    getPackCardPlayButtonClickTracker: PackCardPlayButtonClickTrackerType;
    getPackPlayButtonClickTrackerV2: PackPlayButtonClickTrackerV2Type;
    carouselName: string;
    carouselGuid: string;
}) => {
    const onPlayButtonClick = useCallback(
        (totalTime) => {
            getPackCardPlayButtonClickTracker({
                carouselName,
                carouselId: carouselGuid,
                item: item as Pack, // https://mixgenius.atlassian.net/browse/SP-8405
                page: undefined,
                position: undefined,
            })();

            getPackPlayButtonClickTrackerV2({
                interactionSource: InteractionSource.CardAction,
                item: item as Pack, // https://mixgenius.atlassian.net/browse/SP-8405
            })(totalTime);
        },
        [
            carouselName,
            carouselGuid,
            item,
            getPackCardPlayButtonClickTracker,
            getPackPlayButtonClickTrackerV2,
        ],
    );

    return { onPlayButtonClick };
};

const CardPlayer = ({ item }: { item: Pack | RePack }) => {
    const { carouselName, carouselGuid } = useCarouselContext();

    const {
        getPackCardPlayButtonClickTracker,
        getPackPlayButtonClickTrackerV2,
    } = useTrackingContext();
    const { onPlayButtonClick } = useCardPlayer({
        item,
        getPackCardPlayButtonClickTracker,
        getPackPlayButtonClickTrackerV2,
        carouselName,
        carouselGuid,
    });

    return (
        <PlayerButton
            id={item.guid}
            callback={onPlayButtonClick}
            size="sm"
            variant="subtle"
            isRounded
            isDemo
            key={'player-button'}
        />
    );
};

export default CardPlayer;
